export const FEDERATED_SIGN_IN_STORE_KEY = 'ssoFederatedSignIn';

export const IS_SSO_EMBED_USER_KEY = 'ssoEmbedUser';

export const FEDERATED_SIGN_IN_GENERIC_ERROR_CODE = 'federated_sign_in_error';

export const ALREADY_FOUND_AN_ENTRY_ERROR_MSG = 'Already found an entry for username';

export const EMBED_API_ROUTES = {
  ACCESS_RECORD: '/auth/access-record',
  DATA_SYNC_REQUEST: '/data-sync'
};
